/* Copyright 2014-2020 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the events associated with it. This
 * information is used in order to dispatch the correct events to the peer model. This is also used
 * to map events to actions registered with the action service.
 */

define([
    "dojo/_base/lang",
    "MW/toolstrip/hashes/ControlEventsHash",
    "MW/statusbar/hashes/ControlEventsHash"
], function (lang, ToolstripControlEventsHash, StatusBarControlEventsHash) {
    
    var hash = {};

    lang.mixin(hash, ToolstripControlEventsHash);
    lang.mixin(hash, StatusBarControlEventsHash);

    return hash;
});